import "./App.css";

import AppWrapper from "./containers/Wrapper/Wrapper";
import AppRoute from "./routs";
import AppRouts from "./routs";

function App() {
  return (
    <AppWrapper>
      <div className="App">
        <AppRoute />
      </div>
    </AppWrapper>
  );
}

export default App;
